// extracted by mini-css-extract-plugin
export default {"container":"ScrollContainer_container__pvPIm"};